export type PushStep =
  | "gathering"
  | "filtering"
  | "scan_configs"
  | "scans"
  | "scan_cells"
  | "locations"
  | "screenshots"
  | "classifications"
  | "sport_courts"
  | "pils"
  | "pil_photos"
  | "mapping_photos"
  | "collection"
  | "marking_synced"
  | "completed"
  | "failed";

export interface PushProgressEvent {
  type: "push_progress";
  pushId: string;
  step: PushStep;
  stepLabel: string;
  stepIndex: number;
  totalSteps: number;
  detail?: string;
  itemsProcessed?: number;
  itemsTotal?: number;
}

export interface PushResult {
  success: boolean;
  error?: string;
  stats: {
    scanConfigs: number;
    scans: number;
    scanCells: number;
    locations: number;
    screenshots: number;
    classifications: number;
    sportCourts: number;
    pils: number;
    pilPhotos: number;
    mappingPhotos: number;
    skipped: number;
  };
}

export const PUSH_STEPS: { step: PushStep; label: string }[] = [
  { step: "gathering", label: "Gathering collection data" },
  { step: "filtering", label: "Filtering new locations" },
  { step: "scan_configs", label: "Pushing scan configs" },
  { step: "scans", label: "Pushing scans" },
  { step: "scan_cells", label: "Pushing scan cells" },
  { step: "locations", label: "Pushing locations" },
  { step: "screenshots", label: "Pushing screenshots" },
  { step: "classifications", label: "Pushing classifications" },
  { step: "sport_courts", label: "Pushing sport courts" },
  { step: "pils", label: "Pushing potential installation locations" },
  { step: "pil_photos", label: "Pushing PIL photos" },
  { step: "mapping_photos", label: "Pushing mapping photos" },
  { step: "collection", label: "Pushing collection" },
  { step: "marking_synced", label: "Marking as synced" },
];
